<template>
  <v-container fluid>
    <div
      class="mb-2 mt-10"
      v-if="filtrosActivos.length"
    >
      <span>
        Filtrando por
        <v-chip
          v-for="filtro in filtrosActivos"
          :key="filtro.value"
          class="mr-2"
          outlined
          close
          :color="filtro.color"
          @click:close="$store.commit('listadoAcciones/REMOVE_FILTROS', filtro)"
          small
        >
          {{ filtro.text }}
        </v-chip>
      </span>
    </div>
    <v-card :loading="listadoAcciones.loading">
      <v-app-bar
        flat
        dense
        color="rgba(0, 0, 0, 0)"
      >
        <v-spacer></v-spacer>
        <v-speed-dial
          v-model="fabDots"
          direction="left"
          transition="slide-x-reverse-transition"
          ><template v-slot:activator>
            <v-btn
              icon
              v-model="fabDots"
            >
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                dark
                x-small
                color="info"
                @click="openAll()"
              >
                <v-icon>mdi-expand-all</v-icon>
              </v-btn>
            </template>
            <span> Expandir todo </span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                dark
                x-small
                color="secondary"
                @click="closeAll()"
              >
                <v-icon>mdi-collapse-all</v-icon>
              </v-btn>
            </template>
            <span> Contraer todo </span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                dark
                x-small
                color="accent"
                @click="toggleAll()"
              >
                <v-icon>mdi-toggle-switch-outline</v-icon>
              </v-btn>
            </template>
            <span> Contraer o expandir todo </span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                dark
                x-small
                color="blue-grey lighten-2"
                @click="imprimirListado('pdf')"
              >
                <!-- @click="abrirDialogDesglosar" -->
                <v-badge
                  :content="accionesSeleccionadas.length"
                  :value="accionesSeleccionadas.length"
                  color="red"
                >
                  <v-icon>mdi-printer</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span> Exportar acciones selccionadas a PDF</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                dark
                x-small
                color="green lighten-1"
                @click="imprimirListado('excel')"
              >
                <v-badge
                  :content="accionesSeleccionadas.length"
                  :value="accionesSeleccionadas.length"
                  color="red"
                >
                  <v-icon>mdi-microsoft-excel</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span> Exportar acciones selccionadas a Excel</span>
          </v-tooltip>
          <v-tooltip
            top
            v-if="authUser.isAdmin"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                dark
                x-small
                color="green lighten-1"
                @click="imprimirListado('excel-admin')"
              >
                <v-badge
                  :content="accionesSeleccionadas.length"
                  :value="accionesSeleccionadas.length"
                  color="red"
                >
                  <!-- <v-icon>mdi-microsoft-excel</v-icon> -->
                  <v-icon>mdi-file-excel-outline</v-icon>
                </v-badge>
              </v-btn>
            </template>
            <span> Exportar a Excel (Administrador)</span>
          </v-tooltip>
        </v-speed-dial>
      </v-app-bar>
      <v-card-title style="padding-top: 0px; padding-bottom: 0px">
        <!-- <v-container height="1em" style="border: 1px solid black"> -->
        <v-row
          style="height: 4.5em; margin-top: -1em"
          align="center"
        >
          <v-col>
            <v-text-field
              v-model="buscarAcciones"
              append-icon="mdi-text-box-search-outline"
              label="Buscar"
              single-line
              hide-details
              clearable
            ></v-text-field
          ></v-col>

          <v-col
            xs="12"
            sm="4"
            md="3"
            lg="2"
            class="mt-3"
            style="min-width: 8em"
          >
            <v-autocomplete
              v-model="listadoAcciones.agruparPor"
              @change="$store.commit('listadoAcciones/UPDATE_AGRUPAR_POR', listadoAcciones.agruparPor)"
              :items="listaAgruparPor"
              chips
              label="Agrupar por"
              return-object
            >
              <template v-slot:selection="data">
                <v-chip
                  color="info"
                  outlined
                  small
                  close
                  @click:close="$store.commit('listadoAcciones/UPDATE_AGRUPAR_POR')"
                >
                  {{ data.item.text }}
                </v-chip>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
      </v-card-title>

      <!-- :expanded.sync="accionExpandida" -->
      <v-data-table
        :headers="headers"
        :items="listaAcciones"
        :group-by="listadoAcciones.agruparPor ? listadoAcciones.agruparPor.value : null"
        sort-by="fecha"
        sort-desc
        single-expand
        class="elevation-1"
        ref="table"
        :search="buscarAcciones"
        :items-per-page="15"
        item-key="id"
        show-expand
        show-select
        v-model="accionesSeleccionadas"
        @update:group-by="updateGroupBy($event)"
        @pagination="closeAll"
        @click:row="clicked"
        :expanded.sync="accionExpandida"
        :footer-props="{ itemsPerPageOptions: filasPorPag }"
      >
        <template v-slot:header.data-table-select="{ on, props }">
          <v-simple-checkbox
            color="primary"
            v-bind="props"
            v-on="on"
            @click="toggleSelectAll(props.indeterminate)"
          />
        </template>
        <template
          v-if="!mobile"
          v-slot:expanded-item="{ headers, item }"
        >
          <td :colspan="headers.length">
            <template v-if="item.ambito !== null && item.ambito !== ''">
              <strong>Ambito:</strong>
              {{ item.ambito }}
              <br />
            </template>
            <strong>Comentarios:</strong>
            {{ item.comentarios }}
          </td>
        </template>
        <template v-slot:group.header="{ group, headers, toggle, isOpen, items, isMobile, groupBy }">
          <td colspan="4">
            <v-btn
              small
              icon
              :ref="group"
              :data-open="isOpen"
              @click="toggle"
            >
              <v-icon v-if="isOpen">mdi-chevron-up</v-icon>
              <v-icon
                v-else
                style="transform: rotate(180deg)"
                >mdi-chevron-up</v-icon
              >
            </v-btn>
            <v-icon
              v-if="countSelected(items) === 0"
              dense
              @click="selectGroup(items, group)"
            >
              mdi-checkbox-blank-outline
            </v-icon>
            <v-icon
              v-else-if="countSelected(items) === items.length"
              dense
              @click="deselectGroup(items, group)"
            >
              mdi-checkbox-marked
            </v-icon>
            <v-icon
              v-else
              dense
              @click="selectGroup(items, group)"
            >
              mdi-minus-box
            </v-icon>

            {{ group }}
          </td>

          <template v-if="!mobile">
            <td colspan="1">
              {{ items.length }} ({{ getGroupLength2(groupBy, group) }}) acciones
              <!-- {{ items.length }} ({{ getGroupLength(groupBy, group) }}) acciones -->
            </td>
            <!-- ({{ sumGroupProperty(groupBy, group, "horasReales") }}) -->
            <td colspan="1">
              {{ sumarItemsPorPropiedad(items, 'horasReales') }}
              ({{ sumGroupProperty2(groupBy, group, 'horasReales') }})
            </td>
            <!-- ({{ sumGroupProperty(groupBy, group, "horasCalculadas") }}) -->
            <td colspan="2">
              {{ sumarItemsPorPropiedad(items, 'horasCalculadas') }}
              ({{ sumGroupProperty2(groupBy, group, 'horasCalculadas') }})
            </td>
          </template>
        </template>
      </v-data-table>
    </v-card>

    <v-speed-dial
      fixed
      direction="top"
      transition="slide-y-reverse-transition"
      style="bottom: 37px; right: 30px"
      ><template v-slot:activator>
        <v-btn
          color="teal lighten-1"
          dark
          fab
          @click="$store.commit('listadoAcciones/TOGGLE_DIALOG')"
        >
          <v-icon>mdi-filter-outline</v-icon>
        </v-btn></template
      >
    </v-speed-dial>
    <!-- FIN BOTON ABRIR FILTROS -->

    <!-- DIALOG FILTROS -->
    <v-dialog
      v-model="listadoAcciones.dialog"
      persistent
      max-width="80em"
    >
      <dialog-filtros ref="dialogFiltros" />
    </v-dialog>

    <!-- FIN DIALOG FILTROS -->
  </v-container>
</template>
<script>
  import axios from 'axios'
  import formatearFecha from '../../mixins/formatearFecha'
  import { mapGetters, mapState, mapActions } from 'vuex'
  import DialogFiltros from './DialogFiltros'

  axios.defaults.withCredentials = true
  axios.defaults.baseURL = process.env.VUE_APP_API_URL

  export default {
    name: 'ListadoAcciones',
    mixins: [formatearFecha],
    components: {
      'dialog-filtros': DialogFiltros,
    },
    data() {
      return {
        buscarAcciones: '',
        listaAgruparPor: [
          {
            value: 'cliente',
            text: 'Cliente',
          },
          {
            value: 'tecnico',
            text: 'Tecnico',
          },
        ],
        accionesSeleccionadas: [],
        fabDots: false,
        accionExpandida: [],
        filteredItems: [],
        filasPorPag: [10, 15, 50],
      }
    },
    computed: {
      ...mapState(['listadoAcciones']),
      ...mapState('login', ['authUser']),
      ...mapGetters({
        filtrosActivos: 'listadoAcciones/filtrosActivos',
        listaAcciones: 'listadoAcciones/listaAcciones',
        headers: 'listadoAcciones/headers',
        // getGroupLength: "listadoAcciones/getGroupLength",
        // sumGroupProperty: "listadoAcciones/sumGroupProperty",
        bloqueadas: 'listadoAcciones/bloqueadas',
        fechaInicio: 'listadoAcciones/fechaInicio',
        fechaFin: 'listadoAcciones/fechaFin',
        clienteSeleccionado: 'listadoAcciones/clienteSeleccionado',
        tecnicoSeleccionado: 'listadoAcciones/tecnicoSeleccionado',
        loadingExport: 'listadoAcciones/loadingExport',
      }),
      mobile() {
        return this.$vuetify.breakpoint.xs
      },
    },
    methods: {
      getGroupLength2(groupBy, group) {
        const items = this.$refs.table.$children[0].filteredItems
        return items.filter(item => item[groupBy] === group).length
      },
      sumGroupProperty2(groupBy, group, prop) {
        const h = this.headers.find(elem => elem.hasOwnProperty('meta') && elem.meta === prop)
        if (h !== undefined) prop = h.value
        const items = this.$refs.table.$children[0].filteredItems

        return (
          Math.round(
            items
              .filter(item => item[groupBy] === group)
              .reduce(function (a, b) {
                return a + b[prop]
              }, 0) * 100
          ) / 100
        )
      },
      clicked(e) {
        this.accionExpandida.includes(e) ? (this.accionExpandida = []) : this.accionExpandida.splice(0, 1, e)
      },
      toggleAll() {
        Object.keys(this.$refs).forEach(k => {
          if (this.$refs[k]) this.$refs[k].$el.click()
        })
      },
      closeAll() {
        Object.keys(this.$refs).forEach(k => {
          // console.log(this.$refs[k]);
          if (this.$refs[k] && this.$refs[k].$attrs['data-open']) {
            this.$refs[k].$el.click()
          }
        })
      },
      openAll() {
        Object.keys(this.$refs).forEach(k => {
          if (this.$refs[k] && !this.$refs[k].$attrs['data-open']) {
            this.$refs[k].$el.click()
          }
        })
      },
      toggleSelectAll(indeterminate) {
        if (indeterminate || !this.accionesSeleccionadas.length) {
          const items = this.$refs.table.$children[0].filteredItems
          this.accionesSeleccionadas = [...items]
        } else this.accionesSeleccionadas = []
        console.log(this.accionesSeleccionadas)
      },
      updateGroupBy(e) {
        switch (e) {
          case 'cliente':
          case 'tecnico':
            break
          default:
            this.$store.commit('listadoAcciones/UPDATE_AGRUPAR_POR')
        }
      },
      sumarItemsPorPropiedad(items, prop) {
        const h = this.headers.find(elem => elem.hasOwnProperty('meta') && elem.meta === prop)
        if (h !== undefined) prop = h.value
        return (
          Math.round(
            items.reduce(function (a, b) {
              return a + b[prop]
            }, 0) * 100
          ) / 100
        )
      },
      countSelected(items) {
        const length = this.accionesSeleccionadas.filter(accion => items.some(item => accion.id == item.id)).length

        return length
      },
      deselectGroup(items, group) {
        this.accionesSeleccionadas = this.accionesSeleccionadas.filter(item => {
          return !items.includes(item)
        })
        // Object.keys(this.$refs).forEach((k) => {
        //   if (k === group && this.$refs[k] && !this.$refs[k].$attrs["data-open"])
        //     this.$refs[k].$el.click();
        // });
      },
      selectGroup(items, group) {
        this.accionesSeleccionadas.push.apply(
          this.accionesSeleccionadas,
          items.filter(item => this.accionesSeleccionadas.indexOf(item) < 0)
        )
        // Object.keys(this.$refs).forEach((k) => {
        //   if (k === group && this.$refs[k] && !this.$refs[k].$attrs["data-open"])
        //     this.$refs[k].$el.click();
        // });
      },
      imprimirListado(type) {
        this.$store.dispatch('listadoAcciones/imprimirListado', {
          acciones: this.accionesSeleccionadas,
          type,
        })
      },
      getAcciones() {
        this.$store.dispatch('listadoAcciones/getListaAcciones')
        this.accionesSeleccionadas = []
      },
    },

    created() {
      this.getAcciones()
    },
    watch: {
      bloqueadas() {
        this.getAcciones()
      },
      fechaInicio(newVal, val) {
        // if (val === null || newVal < val || newVal === null) {
        this.getAcciones()
        // }
      },
      fechaFin(newVal, val) {
        // if (val === null || newVal > val || newVal === null) {
        this.getAcciones()
        // }
      },
      clienteSeleccionado(newVal, val) {
        // if (val === null || newVal > val || newVal === null) {
        this.getAcciones()
        // }
      },
      tecnicoSeleccionado(newVal, val) {
        // if (val === null || newVal > val || newVal === null) {
        this.getAcciones()
        // }
      },
      'listadoAcciones.agruparPor': function () {
        setTimeout(() => {
          this.closeAll()
          this.accionesSeleccionadas = []
        }, 10)
      },
    },
  }
</script>
<style>
  .grupo {
    flex: 5;
  }
  .horas {
    flex: 5;
  }
  #generales {
    max-width: 25em;
  }
  #acciones {
    max-width: 40em;
  }
  .select-all {
    visibility: hidden !important;
    padding-left: 2em;
    color: var(--v-info-base);
    cursor: pointer;
  }

  .v-row-group__header:hover span[class='select-all'] {
    visibility: visible !important;
  }
  .filtros-bg {
    @apply pin absolute;
    background: rgba(0, 0, 0, 0.5);
  }
</style>
